export default {
    id: null,
    firstName: "",
    lastName: "",
    administrators: null,
};
